import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import { putApproveDailyWorkReports } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';

const ConfirmApprovalModal = ({ show, onHide, onAccept, dailyWorkReportId }) => {
  const [disableButton, setDisableButton] = useState(false);
  const { setNewToast } = useToast();

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={async () => {
        setDisableButton(true);
        try {
          const response = await putApproveDailyWorkReports('v1', [dailyWorkReportId]);

          onHide();
          setNewToast({
            type: 'SUCCESS',
            message: response.mensaje
          });
          onAccept();
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err.message
          });
        }
        setDisableButton(false);
      }}
      primaryActionDisabled={disableButton}
      primaryActionLabel="Aceptar"
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      title="Aprobar"
      variantHeader="warning"
    >
      <p className="fw-bold text-center">¿Estás seguro de aprobar este elemento?</p>
    </ModalGeneric>
  );
};

export default ConfirmApprovalModal;

ConfirmApprovalModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  dailyWorkReportId: PropTypes.number
};

ConfirmApprovalModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  dailyWorkReportId: null
};
